import React, { useState } from 'react';
import { FaTimes, FaDownload } from 'react-icons/fa'; 
import {  } from 'react-icons/gi'; 
const AR_Project = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const handleProjectClick = (projectName) => {
    if (expandedProject === projectName) {
      setExpandedProject(null);
    } else {
      setExpandedProject(projectName);
    }
  };
  const [downloading, setDownloading] = useState(false);

  const handleClick = () => {
    setDownloading(true);
    setTimeout(() => {
    setDownloading(false);
    window.location.href = "Prince_70 5imagetraget.apk";
    }, 3000);
  };
  return (
    <>
      <div className="parent-react-project">
        <div className="child-react-project" onClick={() => handleProjectClick('Project1')} title='click for more details'>
          <div className="sub-child-project">
            <img src="arp_1.jpeg" alt="Project 2"></img>
          </div>
          <p>Image Target, AR</p>
          <h3>Zoo Application</h3>
          <h4>Read More</h4>
        </div>
        
      </div>
      {expandedProject && (
        <div className="expanded-details-overlay">
          <div className="expanded-details">
            <div className="close-icon" onClick={() => setExpandedProject(null)}>
              <FaTimes />
            </div>
            {expandedProject === 'Project1' && (
              <>
              <h2>Global Chat </h2>
              <div class="react-project-details">
                <div class="child-react-project-details">
                    <h3><span>Project : </span>Android Application</h3>
                    <h3><span>Software : </span>AR - Unity 3D</h3>
                </div>
                <div class="child-react-project-details">
                    
                </div>
              </div>
              <div class="child-react-project-details-1">
                <p>Title: AR Zoo - Unity 3D Zoo Android Application</p>
                <p>Description:</p>
                <p>AR Zoo is an immersive Android application developed by Prince Maurya, leveraging Augmented Reality (AR) and Unity 3D technologies. This innovative app brings the excitement of visiting a zoo right to your fingertips, allowing users to explore virtual zoo environments from the comfort of their devices. Users can interact with lifelike 3D animal models, learn fascinating facts about various species, and experience the thrill of wildlife encounters in an engaging and educational manner. AR Zoo is a testament to the convergence of technology and nature, offering users an unforgettable journey through the animal kingdom.</p>
                <p>For Developers:</p>
                <p>AR Zoo was meticulously crafted using Unity 3D, a powerful game development platform, by Prince Maurya. The application utilizes AR technology to overlay virtual zoo environments onto the real world, creating a seamless and immersive experience for users. With lifelike 3D animal models and interactive features, AR Zoo delivers an engaging educational experience that captivates users of all ages. Experience the magic of the animal kingdom with AR Zoo, developed with passion and expertise by Prince Maurya.</p>
                <hr></hr>
                <h4>Download a android application<br></br>  👇</h4>
                <button onClick={handleClick}>{downloading ? <FaDownload /> : null}{downloading ? 'Downloading' : ' Download'}</button>
              </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AR_Project;
